import React, { useContext } from 'react';
import proyectoContext from '../../context/proyectos/proyectoContext';
import tareaContext from '../../context/tareas/tareaContext';

import { BsTrash } from "react-icons/bs";
import { FaRegEdit } from "react-icons/fa";
import Swal from 'sweetalert2';

const Descripcion = ({tarea, descripcion}) => {

    // Extraer si un proyecto está activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, obtenerUltimosCambios, guardarUltimoCambio } = proyectosContext;

    // Obtener la funcion del context de tarea
    const tareasContext = useContext(tareaContext);
    const { eliminarDescripcion, seleccionarDescripcion } = tareasContext;

    const [ proyectoActual ] = proyecto;

    const handleEliminar = () => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Un descripción que se elimina no se puede recuperar.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f3848',
            cancelButtonColor: '#be3434',
            confirmButtonText: 'Si, ¡eliminalo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                eliminarDescripcion(descripcion._id, tarea._id);
                guardarUltimoCambio(proyectoActual._id, 'Tarea', tarea.nombre, 'Eliminó una descripción');
                obtenerUltimosCambios(proyectoActual._id); // Filtra los ultimos cambios
            }
        });
    }

    return ( 
        <li className="descripcion sombra">
            <div className="descripcion-nombre">
                <p className="fecha-creacion">{descripcion.fechaCreacion}</p>
                <p>{descripcion.contenido}</p>
                <p className="realizado-por"><span>Realizado por:</span> {descripcion.realizadaPor}</p>
            </div>

            <div className="acciones">
                <button
                    type="button"
                    className="btn btn-editar-descripcion"   
                    onClick={() => seleccionarDescripcion(descripcion)}
                >
                    <FaRegEdit />
                </button>
                
                <button
                    type="button"
                    className="btn btn-eliminar-descripcion"
                    onClick={() => handleEliminar()}
                >
                    <BsTrash />
                </button>
            </div>
        </li>
    );
}
 
export default Descripcion;